import React from 'react';

import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { CheckCircle, RadioButtonUnchecked } from '@material-ui/icons';

import { PASSWORD_CRITERIA } from './password-rules.util';

interface PasswordCriteriaListProps {
  password: string;
}

const useStyles = makeStyles((theme) => ({
  criteria: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  criterion: { display: 'flex', alignItems: 'center', gap: theme.spacing(1) },
  criterionMet: { color: theme.palette.client.primary.main },
  criterionIconMet: { color: theme.palette.client.primary.main },
  criterionIcon: { color: theme.palette.text.secondary },
}));

const PasswordCriteriaList: React.FC<PasswordCriteriaListProps> = ({ password }) => {
  const classes = useStyles();

  return (
    <ul className={classes.criteria}>
      {PASSWORD_CRITERIA.map((criterion) => {
        const isMet = criterion.test(password);

        return (
          <li key={criterion.id} className={classes.criterion}>
            {isMet ? (
              <CheckCircle
                fontSize="small"
                className={classes.criterionIconMet}
                titleAccess={`${criterion.label} : critère rempli`}
              />
            ) : (
              <RadioButtonUnchecked
                fontSize="small"
                className={classes.criterionIcon}
                titleAccess={`${criterion.label} : critère manquant`}
              />
            )}
            <Typography variant="body2" className={isMet ? classes.criterionMet : undefined}>
              {criterion.label}
            </Typography>
          </li>
        );
      })}
    </ul>
  );
};

export default PasswordCriteriaList;
